import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Step from "@frog/source/models/Step.js"

export default {
    "affiliation": "good",
    "inventory": {
        "gold": 0,
    },
    "party": {
        "units": {
            "swashbuckler": {
                "key": "swashbuckler",
                "jobKey": "pirates/sword",
                "affiliation": "good",

                "canBetray": false,
                "isRecruited": true,

                "maxhealth": 60,
                "skills": [
                    "inflict-damage",
                    "restore-health",
                    "push",
                    "recruit",
                ],
                "properties": [
                    "mutually-healing",
                ],

                "name": "Eleanor",
                "subtitle": "Swashbuckler Lv3",
                "faceKey": "human",
                "bodyKey": "good",
                "imageUrl": require("@frog/source/assets/images/frog-tactics/stage/units/eleanora.png"),

                "sprites": {
                    "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/eleanora.png"),
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-neutral.png"),
                    "happy": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-happy.png"),
                    "wink": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-wink.png"),
                    "angry": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-angry.png"),
                    "challenge": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-challenge.png"),

                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-challenge.png"),
                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-angry.png"),
                },

                "dialogue": {
                    "death": [
                        "SWASHBUCKLER: Damn, that's it for me.",
                    ],
                },
            },

            "swindler": {
                "key": "swindler",
                "jobKey": "pirates/dagger",
                "affiliation": "good",

                "canBetray": true,
                "isRecruited": true,

                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "pull",
                    "recruit",
                ],
                "ai": {
                    "behaviors": [
                        "non-player-enemies first"
                    ]
                },

                "name": "Sylvester",
                "subtitle": "Rogue Lv3",
                "faceKey": "human",
                "bodyKey": "good",
                "imageUrl": require("@frog/source/assets/images/frog-tactics/stage/units/sylvester.png"),

                "sprites": {
                    "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/sylvester.png"),
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-neutral.png"),
                    "nervous": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-nervous.png"),
                    "smooth": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-smooth.png"),

                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-smooth.png"),
                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-nervous.png"),
                },

                "dialogue": {
                    "death": [
                        "SWINDLER: Damn, that's it for me.",
                    ],
                    "betrayed": [
                        "SWINDLER: I couldn't have done it better myself.",
                        "SYLVESTER HAS LEFT YOUR PARTY",
                    ]
                },
            },


            "castaway": {
                "key": "castaway",
                "jobKey": "pirates/spear",
                "affiliation": "good",

                "canBetray": true,
                // "isRecruited": true,

                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "swap",
                    "recruit",
                ],
                "properties": [
                    "neutral-character",
                    "immortal"
                ],
                "ai": {
                    "behaviors": [
                        "non-player-enemies first"
                    ]
                },

                "name": "Smee",
                "subtitle": "Ranger Lv5",
                "faceKey": "human",
                "bodyKey": "good",
                "imageUrl": require("@frog/source/assets/images/frog-tactics/stage/units/smee.png"),

                "sprites": {
                    "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/smee.png"),
                    "orange": require("@frog/source/assets/images/frog-tactics/stage/units/smee.viking.png"),
                    "red": require("@frog/source/assets/images/frog-tactics/stage/units/smee.yakuza.png"),
                    "blue": require("@frog/source/assets/images/frog-tactics/stage/units/smee.knight.png"),
                    "purple": require("@frog/source/assets/images/frog-tactics/stage/units/smee.swashbuckler.png"),
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/smee-neutral.png"),
                    "happy": require("@frog/source/assets/images/pirate-tactics/portraits/smee-happy.png"),
                    "angry": require("@frog/source/assets/images/pirate-tactics/portraits/smee-angry.png"),
                    "flavor": require("@frog/source/assets/images/pirate-tactics/portraits/smee-wearied.png"),

                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/smee-wearied.png"),
                },

                "dialogue": {
                    "death": [
                        (stage) => {
                            if(stage.flags["CastawayDied"] != true) {
                                return [
                                    "CASTAWAY: And so my misery continues.",
                                    Step.flag("CastawayDied", true)
                                ]
                            }
                        }
                    ],
                    "truedeath": [
                        (stage) => {
                            return [
                                PlotSteps.Wait(1000),
                                "CASTAWAY: Finally, it's over.",
                            ]
                        }
                    ],
                    "betrayed": [
                        "CASTAWAY: Fuck.",
                        "SMEE HAS LEFT YOUR PARTY",
                    ],
                },

                "facts": [
                    "Can not die?",
                ]
            },
            "mercenary": {
                "key": "mercenary",
                "jobKey": "pirates/gun",
                "affiliation": "good",

                "canBetray": true,
                "isRecruited": true,

                "attackrange": {
                    "min": 2,
                    "max": 5,
                    "directions": [
                        {"x": -1, "y": 0},
                        {"x": +1, "y": 0},
                        {"x": 0, "y": -1},
                        {"x": 0, "y": +1},
                    ]
                },
                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "pull",
                    "recruit",
                ],
                "properties": [
                    "neutral-character",
                ],
                "ai": {
                    "behaviors": [
                        "non-player-enemies first"
                    ]
                },

                "facts": [
                    "Can attack in horizontal lines.",
                ],

                "name": "Joe Boots",
                "subtitle": "Rogue Lv5",
                "faceKey": "human",
                "bodyKey": "good",
                "weaponImageKey": "rifle",
                "imageUrl": require("@frog/source/assets/images/frog-tactics/stage/units/joe.png"),

                "sprites": {
                    "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/joe.png"),
                    "orange": require("@frog/source/assets/images/frog-tactics/stage/units/joe.viking.png"),
                    "red": require("@frog/source/assets/images/frog-tactics/stage/units/joe.yakuza.png"),
                    "blue": require("@frog/source/assets/images/frog-tactics/stage/units/joe.knight.png"),
                    "purple": require("@frog/source/assets/images/frog-tactics/stage/units/joe.swashbuckler.png"),
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/joe-neutral.png"),
                    "happy": require("@frog/source/assets/images/pirate-tactics/portraits/joe-happy.png"),
                    "angry": require("@frog/source/assets/images/pirate-tactics/portraits/joe-angry.png"),
                    "flavor": require("@frog/source/assets/images/pirate-tactics/portraits/joe-flavor.png"),

                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/joe-flavor.png"),
                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/joe-angry.png"),
                },

                "dialogue": {
                    "death": [
                        "MERCENARY: Out of luck.",
                        "MERCENARY: Coin wasn't good enough, anyways.",
                    ],
                    "betrayed": [
                        "MERCENARY: So I see how it is.",
                        "JOE BOOTS HAS LEFT YOUR PARTY",
                    ]
                },
            },
            "bard": {
                "key": "bard",
                "jobKey": "pirates/gun",
                "affiliation": "good",


                "canBetray": true,
                // "isRecruited": true,

                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "rally",
                    "recruit",
                ],
                "properties": [
                    "neutral-character",
                ],
                "ai": {
                    "behaviors": [
                        // "non-player-enemies first" // not the bard lol
                    ]
                },

                "facts": [
                    "Can rally an ally to take another turn.",
                ],

                "name": "Robin",
                "subtitle": "Bard Lv5",
                "faceKey": "human",
                "bodyKey": "good",
                "imageUrl": require("@frog/source/assets/images/frog-tactics/stage/units/robin.png"),

                "sprites": {
                    "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/robin.png"),
                    "orange": require("@frog/source/assets/images/frog-tactics/stage/units/robin.viking.png"),
                    "red": require("@frog/source/assets/images/frog-tactics/stage/units/robin.yakuza.png"),
                    "blue": require("@frog/source/assets/images/frog-tactics/stage/units/robin.knight.png"),
                    "purple": require("@frog/source/assets/images/frog-tactics/stage/units/robin.swashbuckler.png"),
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/robin-neutral.png"),
                    "happy": require("@frog/source/assets/images/pirate-tactics/portraits/robin-happy.png"),
                    "angry": require("@frog/source/assets/images/pirate-tactics/portraits/robin-angry.png"),
                    "flavor": require("@frog/source/assets/images/pirate-tactics/portraits/robin-tongue.png"),

                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/robin-tongue.png"),
                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/robin-angry.png"),
                },

                "dialogue": {
                    "death": [
                        "BARD: Damn, that smarts.",
                        "BARD: I'll be back - just you wait and see.",
                    ],
                    "betrayed": [
                        "BARD: Oho~",
                        "ROBIN HAS LEFT YOUR PARTY",
                    ],
                },
            },

            "viking": {
                "key": "viking",
                "jobKey": "pirates/hammer",
                "affiliation": "good",

                // "isRecruited": true,
                "canBetray": true,
                "preferredAffilation": "orange",

                "maxhealth": 50,
                "skills": [
                    "inflict-damage",
                    "smite",
                    "recruit",
                ],
                "ai": {
                    "behaviors": [
                        "non-player-enemies first"
                    ]
                },

                "facts": [
                    "Can push a unit up to 2 tiles.",
                ],

                "name": "Flint",
                "subtitle": "Barbarian Lv9",
                "bodyKey": "good",
                "imageUrl": require("@frog/source/assets/images/frog-tactics/stage/units/flint.png"),

                "sprites": {
                    "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/flint.png"),
                    "orange": require("@frog/source/assets/images/frog-tactics/stage/units/flint.png"),
                    "red": require("@frog/source/assets/images/frog-tactics/stage/units/flint.yakuza.png"),
                    "blue": require("@frog/source/assets/images/frog-tactics/stage/units/flint.knight.png"),
                    "purple": require("@frog/source/assets/images/frog-tactics/stage/units/flint.swashbuckler.png"),
                },
                "hasBigPortraits": true,
                "portraits": {
                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/flint-neutral.png"),
                    "happy": require("@frog/source/assets/images/pirate-tactics/portraits/flint-happy.png"),
                    "angry": require("@frog/source/assets/images/pirate-tactics/portraits/flint-angry.png"),

                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/flint-happy.png"),
                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/flint-angry.png"),
                },

                "dialogue": {
                    "death": [
                        "VIKING: Bah, the winds have failed me.",
                    ],
                    "betrayed": [
                        "VIKING: Aye, that way goes the game.",
                        "FLINT HAS LEFT YOUR PARTY",
                    ],
                },
            },
            "yakuza": {
                "key": "yakuza",
                "jobKey": "pirates/dagger",
                "affiliation": "good",

                "canBetray": true,
                "preferredAffilation": "purple",

                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "swap",
                    "recruit",
                ],

                "name": "Zheng",
                "subtitle": "Sorcerer Lv9",
                "bodyKey": "good",
                "imageUrl": require("@frog/source/assets/images/frog-tactics/stage/units/zheng.png"),

                "sprites": {
                    "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/zheng.png"),
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/zheng-neutral.png"),
                    "happy": require("@frog/source/assets/images/pirate-tactics/portraits/zheng-happy.png"),
                    "angry": require("@frog/source/assets/images/pirate-tactics/portraits/zheng-angry.png"),

                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/zheng-happy.png"),
                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/zheng-angry.png"),
                },
                "ai": {
                    "behaviors": [
                        "non-player-enemies first"
                    ]
                },

                "dialogue": {
                    "death": [
                        "YAKUZA: This means nothing.",
                        "YAKUZA: This is not the last you've heard of me.",
                    ],
                    "betrayed": [
                        "YAKUZA: I should've known.",
                        "ZHENG HAS LEFT YOUR PARTY",
                    ],
                },
            },
            "knight": {
                "key": "knight",
                "jobKey": "pirates/spear",
                "affiliation": "good",


                "canBetray": true,
                "preferredAffilation": "blue",

                "maxhealth": 40,
                "moverange": 3,
                "skills": [
                    "inflict-damage",
                    "swap",
                    "recruit",
                ],
                "ai": {
                    "behaviors": [
                        "non-player-enemies first"
                    ]
                },

                "facts": [
                    "Can move 3(!) squares a turn!",
                ],

                "name": "Beckett",
                "subtitle": "Paladin Lv9",
                "bodyKey": "good",
                "imageUrl": require("@frog/source/assets/images/frog-tactics/stage/units/beck.png"),

                "sprites": {
                    "neutral": require("@frog/source/assets/images/frog-tactics/stage/units/beck.png"),
                    "orange": require("@frog/source/assets/images/frog-tactics/stage/units/beck.viking.png"),
                    "red": require("@frog/source/assets/images/frog-tactics/stage/units/beck.yakuza.png"),
                    "blue": require("@frog/source/assets/images/frog-tactics/stage/units/beck.png"),
                    "purple": require("@frog/source/assets/images/frog-tactics/stage/units/beck.swashbuckler.png"),
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/beck-neutral.png"),
                    "happy": require("@frog/source/assets/images/pirate-tactics/portraits/beck-happy.png"),
                    "angry": require("@frog/source/assets/images/pirate-tactics/portraits/beck-angry.png"),
                    "flavor": require("@frog/source/assets/images/pirate-tactics/portraits/beck-flavor.png"),

                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/beck-happy.png"),
                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/beck-angry.png"),
                },

                "dialogue": {
                    "death": [
                        "KNIGHT: I have failed you, my king.",
                        "KNIGHT: I must retreat.",
                    ],
                    "betrayed": [
                        "BECKETT HAS LEFT YOUR PARTY",
                    ],
                },
            },
        }
    },
}
